import { createStorage } from "../../storage/StorageClass";

const BASE_URL = "/travel/service/metrics";
const APPLICATION_JSON = "application/json;charset=UTF-8";

const createSendMetric = (repository, scope) => {
  const storage = createStorage(repository, scope);
  return (key, body) => {
    const disableGrafana = storage.get("disableGrafana");

    if (!disableGrafana) {
      fetch(`${BASE_URL}/${key}`, {
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": APPLICATION_JSON,
        },
        body: JSON.stringify(body),
      });
    }
  };
};

export default createSendMetric;
